(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initReveal = (root) => {
    const items = [...root.querySelectorAll('[data-elo17-reveal]')];
    root.classList.add('is-ready');

    if (!('IntersectionObserver' in window) || reducedMotion.matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -8% 0px' },
    );

    items.forEach((item) => observer.observe(item));
  };

  const initRail = (rail) => {
    const track = rail.querySelector('[data-elo17-track]');
    const slides = [...(track?.children || [])];
    const previous = rail.querySelector('[data-elo17-prev]');
    const next = rail.querySelector('[data-elo17-next]');
    const status = rail.querySelector('[data-elo17-status]');
    if (!track || slides.length < 2) return;

    const currentIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      return slides.reduce(
        (closest, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          return distance < closest.distance ? { index, distance } : closest;
        },
        { index: 0, distance: Number.POSITIVE_INFINITY },
      ).index;
    };

    const update = () => {
      const index = currentIndex();
      if (status) status.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    const goTo = (index) => {
      slides[Math.max(0, Math.min(slides.length - 1, index))]?.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    };

    previous?.addEventListener('click', () => goTo(currentIndex() - 1));
    next?.addEventListener('click', () => goTo(currentIndex() + 1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const init = (root) => {
    if (root.dataset.elo17Ready === 'true') return;
    root.dataset.elo17Ready = 'true';
    initReveal(root);
    root.querySelectorAll('[data-elo17-rail]').forEach(initRail);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-elo17]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
